module.exports = __webpack_public_path__ + "static/media/nam101.5c1c4389.png";